import { render, staticRenderFns } from "./GeneralSales.vue?vue&type=template&id=3a28ad3e&"
import script from "./GeneralSales.vue?vue&type=script&lang=js&"
export * from "./GeneralSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports